import { useAxios } from "@/app/providers/AxiosProvider";
import handleError from "@lib/helpers/handleError";
import { useQuery } from "@tanstack/react-query";

export default function useSystemSkills() {
  const api = useAxios();
  const { data, error, isLoading } = useQuery({
    queryKey: ["system-skills"],
    queryFn: () => api.get(`/settings/systemSkills`),
  });

  handleError(error);

  const skills = data?.data ?? [];

  return { skills, isLoading };
}
